<script>
export default {
  computed: {
    attachments () {
      const documents = Array.isArray(this.params?.data?.documents) ? this.params.data.documents : []
      const files = Array.isArray(this.params?.data?.files) ? this.params.data.files : []
      if (!documents.length) {
        return files
      }
      if (!files.length) {
        return documents
      }
      const seen = new Set()
      return [...documents, ...files].filter((file) => {
        const key = file?.id || file?.uuid || file?.name || file?.url
        if (!key || seen.has(key)) {
          return false
        }
        seen.add(key)
        return true
      })
    }
  },
  methods: {
    copyUUIDToClipboard (uuid) {
      navigator.clipboard.writeText(uuid)
        .then(() => {
          this.$buefy.notification.open({
            message: 'Identifiant unique copié dans le presse-papiers.',
            type: 'is-success',
            position: 'is-bottom',
            duration: 5000
          })
        })
    },
    getAttachmentLabel (file) {
      return file?.name || file?.filename || file?.title || file?.url || 'Document'
    }
  }
}
</script>

<template>
  <div class="space-y-2 py-4 whitespace-normal">
    <div class="flex">
      <div class="w-1/6 text-right font-bold mr-2">UUID</div>
      <div class="w-4/5 select-all" @click="copyUUIDToClipboard(params.data.uuid)">{{ params.data.uuid }}</div>
    </div>
    <div class="flex">
      <div class="w-1/6 text-right font-bold mr-2">Question</div>
      <div class="w-4/5">{{ params.data.title }}</div>
    </div>
    <div class="flex">
      <div class="w-1/6 text-right font-bold mr-2">Réponse</div>
      <div class="w-4/5" v-html="params.data.response"></div>
    </div>
    <div class="flex">
      <div class="w-1/6 text-right font-bold mr-2">Mots-clés</div>
      <div class="w-4/5">
        {{ params.data.keywords.join(', ') }}
      </div>
    </div>
    <div class="flex">
      <div class="w-1/6 text-right font-bold mr-2">Pièces jointes</div>
      <div class="w-4/5">
        <ul v-if="attachments.length">
          <li v-for="file in attachments" :key="file.id || file.uuid || file.name">
            <a :href="file.url" target="_blank" rel="noopener noreferrer">
              <b-icon icon="fas fa-eye" class="mr-2" />{{ getAttachmentLabel(file) }}
            </a>
          </li>
        </ul>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>
